import { AxiosInstancePlus } from '@tencent/oneid-request';
import message from 'common/components/Message';
import { IMG_SAFE_CHECK_STATUS } from 'common/constants/Constants';
import { http } from 'common/http';
import BaseApi from 'common/http/BaseApi';
import i18n from 'common/locales';

class Account extends BaseApi {
  public axiosInstance: AxiosInstancePlus = http;
  public prefixURL = '/admin/v2/account';

  public curCosUrl = '';

  /**
   * 上传头像并轮询审核，内部轮询实现，只需调用uploadAvatar即可
   */
  async uploadAvatar(props: {
    img: File;
    uploadResource: string;
    businessId?: string;
    originalUrl?: string;
    onStatusChange?: (url: string) => void;
    defaultImage?: string;
  }): Promise<
    undefined | { cosUrl: string; cosId: string; safeChecked?: boolean; safeStatus?: any }
  > {
    const { img, uploadResource, businessId, originalUrl, onStatusChange } = props;
    const businessInfo = businessId ? { business_id: businessId } : undefined;

    const uploadRes = await this.uploadImg({
      upload_resource: uploadResource,
      img,
      business_info: businessInfo,
    });
    if (!uploadRes?.cosUrl) return;

    this.curCosUrl = uploadRes.cosUrl;

    // 上传后立即预览新图片
    onStatusChange?.(uploadRes.cosUrl);
    // 轮询审核状态，使用 pollingCallback
    const safeStatus = await new Promise((resolve) => {
      this.getSafeCheckStatus(uploadRes.cosUrl, {
        skipShowError: true,
        pollingConfig: {
          pollingWait: 1000,
          onSuccess: (res: { status: IMG_SAFE_CHECK_STATUS }) => {
            if (this.curCosUrl !== uploadRes.cosUrl) return true;
            if (res?.status === IMG_SAFE_CHECK_STATUS.FAIL) {
              resolve(res?.status);
              message.error(i18n.t('图片保存失败，请重新上传'));
              onStatusChange?.(originalUrl || '');
              return true;
            }
            if (res?.status === IMG_SAFE_CHECK_STATUS.SUCCESS) {
              resolve(res?.status);
              // 审核通过，无需回退，保留新图片
              return true;
            }
            return false;
          },
          onEnd: () => {
            resolve(IMG_SAFE_CHECK_STATUS.FAIL);
            message.error(i18n.t('图片保存失败，请重新上传'));
            onStatusChange?.(originalUrl || '');
          },
          maxPollingCount: 60,
        },
      });
    });
    const isPass = safeStatus === IMG_SAFE_CHECK_STATUS.SUCCESS;
    const isFail = safeStatus === IMG_SAFE_CHECK_STATUS.FAIL;
    let cosUrl = uploadRes.cosUrl;
    if (isFail) {
      cosUrl = originalUrl || '';
    } else if (isPass) {
      cosUrl = uploadRes.cosUrl;
    }
    return {
      cosUrl,
      cosId: uploadRes.cosId,
      safeChecked: !!isPass,
      safeStatus,
    };
  }
}
export default new Account();
